import React, { useContext, useEffect, useLayoutEffect, useState, useRef } from 'react';
import { map } from "lodash";
import cn from "classnames";
import renderRawHtml from '../../../../common/render_raw_html';
import slideImage0 from '../../../../../../images/paypal/everywhere/welcome/0.jpg';
import slideImage1 from '../../../../../../images/paypal/everywhere/welcome/1.jpg';
import slideImage2 from '../../../../../../images/paypal/everywhere/welcome/2.jpg';
import slideImage3 from '../../../../../../images/paypal/everywhere/welcome/3.jpg';
import slideImage4 from '../../../../../../images/paypal/everywhere/welcome/4.jpg';
import slideImage5 from '../../../../../../images/paypal/everywhere/welcome/5.jpg';
import { GlobalContext } from "../contexts/appContexts";
import CloseAppXSign from '../components/closeAppXSign';

const slideImages = [
  slideImage0, slideImage1, slideImage2, slideImage3, slideImage4, slideImage5
];

const slidesList = [
  {
    id: 1,
    title: "<div>Pay,</div><div>send,</div><div>and</div><div>save</div><div>smarter.</div>",
    fontLg: true,
    position: "bottom"
  },
  {
    id: 2,
    title: "<div>Shop online</div><div>and now in</div><div>stores, too.</div>",
    showButton: true,
    position: "bottom"
  },
  {
    id: 3,
    title: "<div>Get cash on</div><div>cash back! It</div><div>all adds up.</div>",
    showButton: true,
    position: "top"
  },
  {
    id: 4,
    title: "<div>Send money</div><div>instantly to</div><div>just about</div><div>anyone</div><div>anywhere.</div>",
    showButton: true,
    position: "bottom"
  },
  {
    id: 5,
    title: "<div>Pay with</div><div>confidence.</div><div>Safety and</div><div>privacy are</div><div>built in.</div>",
    showButton: true,
    position: "top"
  }
];

const Intro = ({ onCloseApp }) => {
  return (
    <div className="welcome-intro">
      {
        !!onCloseApp &&
        <div className="slideshow_header -reverse-grid">
          <CloseAppXSign onClick={ onCloseApp } />
        </div>
      }
      <img className="welcome-intro_bg" src={ slideImages[0] } alt="" />
      <svg className="welcome-intro_icon">
        <use xlinkHref="#svg_paypal" />
      </svg>
    </div>
  );
};

const Slideshow = ({ nextStep, onSkip, slideTime, onCloseApp, reboarding, onSignUpClick }) => {
  const delayAfter = 1000;
  const [ activeSlide, setActiveSlide ] = useState(1);
  const intervalId = useRef(null);
  const timeoutId = useRef(null);

  useEffect(() => {
    let currentSlide = activeSlide;
    intervalId.current = setInterval(() => {
      if (currentSlide < slidesList.length) {
        currentSlide = currentSlide + 1;
        setActiveSlide(currentSlide);
      }
    }, slideTime);

    return () => {
      if (intervalId.current) {
        clearInterval(intervalId.current);
      }
    };
  }, [ activeSlide ]);

  useLayoutEffect(() => {
    if (activeSlide >= slidesList.length) {
      timeoutId.current = setTimeout(() => {
        setActiveSlide(1);
      }, delayAfter + slideTime);
    }
    return () => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
    };
  }, [ activeSlide ]);

  const skipStep = () => {
    onSkip && onSkip();
    let newSlide = activeSlide + 1;
    if (activeSlide >= slidesList.length) {
      newSlide = 1;
    }
    setActiveSlide(newSlide);
  };

  const onStart = () => {
    nextStep();
  };

  const handleSignUpClick = () => {
    onSignUpClick && onSignUpClick();
  };

  return (
    <div className="slideshow">
      <div className="slideshow_header -reverse-grid">
        <ul className="slideshow_header-steps">
          {
            map(slidesList, (slide, index) => (
              <li
                key={ index }
                style={ { 'animationDuration': `${slideTime}ms` } }
                className={
                  cn(
                    "slideshow_header-step",
                    { '-current': index + 1 === activeSlide },
                    { '-completed': index + 1 < activeSlide }
                  )
                }
              />
            ))
          }
        </ul>
        <button
          className="slideshow_header-button button -white -xs skip-button"
          onClick={ skipStep }
        >
          Skip
        </button>
        { !!onCloseApp && <CloseAppXSign onClick={ onCloseApp } /> }
      </div>
      <ul className="slideshow_list">
        {
          map(slidesList, (slide, index) => (
            <li
              key={ index }
              className={
                cn(
                  "slideshow_list-item",
                  { '-active': index + 1 === activeSlide },
                  { '-out': index + 1 === (activeSlide === 1 ? slidesList.length : activeSlide - 1) },
                  `-slide-${slide.id}`
                )
              }
            >
              <div className="slideshow_item">
                <div className="slideshow_item-bg-wrap">
                  <img className="slideshow_item-bg" src={ slideImages[index + 1] } alt="" />
                </div>
                <div className={ `slideshow_item-content -position-${slide.position || 'bottom'}` }>
                  <h1
                    className={ `slideshow_item-title ${slide.fontLg ? '-lg' : ''}` }
                    { ...renderRawHtml(slide.title) }
                  />
                  {
                    slide.showButton &&
                    <div className={ cn("slideshow_item-button", { '-grid': reboarding }) }>
                      {
                        reboarding ? (
                          <>
                            <button className="button -full-width -black" onClick={ onStart }>
                              Log In
                            </button>
                            <button
                              disabled
                              className="button -full-width -black"
                              onClick={ handleSignUpClick }
                            >
                              Sign Up
                            </button>
                          </>
                        ) : (
                          <button className="button -full-width -black" onClick={ onStart }>
                            Get Started
                          </button>
                        )
                      }
                    </div>
                  }
                </div>
              </div>
            </li>
          ))
        }
      </ul>
    </div>
  );
};

const Welcome = ({ delayFirst = 2000, slideTime = 3000, reboarding, onSignUpClick }) => {
  const { nextStep, mergeData, closeFullApp } = useContext(GlobalContext);
  const [ startSlideshow, setStartSlideshow ] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setStartSlideshow(true);
    }, delayFirst);
  }, []);

  const handleOnSkip = () => {
    mergeData({ welcomeSkipClick: true });
  };

  return (
    <>
      <Intro onCloseApp={ closeFullApp } />
      {!!startSlideshow && (
        <Slideshow
          reboarding={ reboarding }
          onSignUpClick={ onSignUpClick }
          onSkip={ handleOnSkip }
          nextStep={ nextStep }
          slideTime={ slideTime }
          onCloseApp={ closeFullApp }
        />
      )}
    </>
  );
};

export default Welcome;


